import { objectsNaviPanelCtrl } from './objects.navi.panel.controller';
import template from './objects.navi.panel.html';

export const objectsNaviPanel: angular.IDirectiveFactory = () => ({
  bindToController: true,
  template,
  controller: objectsNaviPanelCtrl,
  controllerAs: 'vm',
  restrict: 'A',
  scope: {
    sectionId: '@',
  },
});
